module.exports = __webpack_public_path__ + "img/19.5fcddef2.png";